import React, { ChangeEvent } from 'react'
import styled from '@emotion/styled'

const Wrapper = styled.p`
  display: inline;
  input {
    width: 100%;
    height: 34px;
    color: #454f63;
    border: #ebebeb solid 2px;
    border-radius: 8px;
    padding: 5px;
    transition: 0.3s;
    -webkit-appearance: none;
    &:focus {
      border-color: #3abd9e;
    }
    &:hover {
      border-color: #3abd9e !important;
      background: #ffffff;
    }
    &:disabled,
    &:disabled:hover {
      border-color: #ebebeb !important;
      color: #a9b7c2;
      background: rgba(220, 220, 220, 0.4);
      svg {
        color: #a9b7c2 !important;
      }
    }
  }
`

type IProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  /** クラス名 */
  className?: string
  /** 変更時コールバック */
  onChangeValue?: (value: string) => void
}
/**
 * 共通1行インプットエリア
 * @param props
 */
const CommonInput = (props: IProps): JSX.Element => {
  const { className = '', onChangeValue, ...otherProps } = props

  /** 変更時処理 */
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeValue && onChangeValue(e.target.value)
  }

  return (
    <Wrapper className={className}>
      <input {...otherProps} onChange={onChange} />
    </Wrapper>
  )
}
export default CommonInput
